import React, { useEffect } from "react";

const AdComponent = () => {
  useEffect(() => {
    // Ensure the adsbygoogle object exists and reinitialize only when needed
    if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
      try {
        window.adsbygoogle.push({});
      } catch (error) {
        console.error("Adsbygoogle push error:", error);
      }
    }
  }, []); // Run only once on mount

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-3853022968706679" // Your AdSense Client ID
      data-ad-slot="4825933804"               // Your Ad Unit ID
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
};

export default AdComponent;
